import API from '@/lib/API.js'
import comun from './comun.js'
const reportes = {
    namespaced: true,
    state: {
        Lista: [],
        Seleccionado: undefined
    },
    mutations: {
        init(state) {
            state.Seleccionado = undefined
        },
        set(state, payload) {
            state.Lista = payload;
        },
        select(state, payload) {
            state.Seleccionado = payload;
        },
    },
    actions: {
        async set({
            commit,
            state
        }) {
            if (state.Lista.length === 0) {
                commit("comun/cargando")
                let data = await API.Reportes.traerTodos();
                commit("set", data)
                commit("comun/fincarga")
            }
        },
        select({
            commit
        }, payload) {
            commit("select", payload)
        },
        selectPorId({
            commit,
            state
        }, payload) {
            commit("comun/cargando")
            let sec = state.Lista.find((x) => x.id_seccional == payload)
            commit("select", sec)
            commit("comun/fincarga")
        },
    },
    modules: {
        comun,
    }
}
export default reportes;